import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ATTRIBUTE_LABEL } from "../../../Helpers/Labels/AttributeLabel";
import RelationCardinality from "./RelationCardinality";
import RelationCardinalityDropdown from "./RelationCardinalityDropdown";
import { cloneElement } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

function RecommendedRelationCard({
    selected,
    fromEntityName, toEntityName, cardinality,
    addReferenceAttribute, referenceAttribute, referenceAttributes,
    onCardinalityChange, onAddReferenceAttributeChange, onReferenceAttributeChange,
    onToggle, onSwap, error
}) {

    const { t } = useTranslation("linked_entity/recommended_relation_card");

    function handleCardinalityChange(e) {
        onCardinalityChange(e);
    }

    function handleAddReferenceAttributeChange(e) {
        e.syntheticEvent.stopPropagation();
        onAddReferenceAttributeChange(e);
    }

    function handleReferenceAttributeChange(e) {
        e.syntheticEvent.stopPropagation();
        onReferenceAttributeChange(e);
    }

    function handleToggle(e) {
        onToggle(e);
    }

    function handleSwap(e) {
        onSwap(e);
    }

    function isValidReferenceAttributesPresent() {
        return referenceAttributes && referenceAttributes.length > 0;
    }

    return (
        <div className={`recommended-relation-card card shadow-sm rounded border ${selected ? 'border-2 border-primary' : 'border-2 border-3'}`} onClick={handleToggle} style={{ cursor: 'pointer' }}>
            <div className="card-body d-flex flex-column gap-2 py-2 px-4" style={{ paddingBottom: 16 }}>
                {/* Top row: swap button and cardinality dropdown */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    {cardinality === "1-*" ? (
                        <button className="btn btn-light" onClick={handleSwap} type="button">
                            <i className="fa-solid fa-right-left"></i>
                        </button>
                    ) : (
                        <span className="btn empty-button">&nbsp;&nbsp;</span>
                    )}
                    <div style={{ minWidth: 120 }}>
                        <RelationCardinalityDropdown
                            value={cardinality}
                            onChange={handleCardinalityChange}
                        />
                    </div>
                </div>
                {/* Main content */}
                <RelationCardinality
                    fromEntityName={fromEntityName}
                    toEntityName={toEntityName}
                    cardinality={cardinality}
                    descriptionAlign="start"
                />
                {/* Error message */}
                {error && (
                    <div className="text-danger font-size-2 mt-1">
                        <i className="fa-solid fa-exclamation-triangle me-1"></i>
                        {error}
                    </div>
                )}
                {/* Reference attribute section */}
                <div className="mt-2">
                    {cardinality === "1-*" && isValidReferenceAttributesPresent() ? (
                        <label onClick={e => e.stopPropagation()} className="d-inline-flex align-items-center">
                            <Checkbox
                                value={addReferenceAttribute}
                                checked={addReferenceAttribute}
                                disabled={!isValidReferenceAttributesPresent()}
                                onChange={handleAddReferenceAttributeChange}
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            />
                            &nbsp;&nbsp;
                            <span>
                                {t("add_reference_property", {
                                    ns: "linked_entity/recommended_relation_card",
                                    entityName: toEntityName
                                })}
                            </span>
                        </label>
                    ) : null}
                    {addReferenceAttribute ? (
                        <div className="mt-2">
                            <DropDownList
                                ariaLabel={`Reference ${ATTRIBUTE_LABEL}`}
                                data={referenceAttributes}
                                value={referenceAttribute}
                                valueRender={(element, value) => {
                                    return cloneElement(
                                        element,
                                        { ...element.props },
                                        <span aria-label="reference-attribute-value">
                                            {value}
                                        </span>
                                    )
                                }}
                                onChange={handleReferenceAttributeChange}
                                onOpen={e => {
                                    e.syntheticEvent.stopPropagation();
                                }}
                                onClose={e => {
                                    e.syntheticEvent.stopPropagation();
                                }}
                                disabled={!referenceAttributes || referenceAttributes.length === 0}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

/*
<div className="col-4 bg-white px-1">
    <button
        key={index}
        className={`w-100 h-100 bg-white ${relation.selected ? "border-primary border-3" : "border border-secondary"}`}
        onClick={() => toggleCheckbox(index)}
        disabled={relation.isStatic}
    >
        <div className={`h-100 d-flex flex-column align-items-center justify-content-center py-1 px-2`}>
            <div className="btn border-0 w-100" onClick={() => toggleCheckbox(index)}>
                <SelectedCardinality
                    selected={relation.cardinality}
                    firstEntityName={relation.from}
                    secondEntityName={relation.to} />
            </div>
            <div>
                {
                    relation.cardinality === "1-*"
                    ?
                    <label
                        onClick={e => e.stopPropagation()}>
                        <Checkbox
                            value={relation.showReferenceAttribute}
                            checked={relation.showReferenceAttribute}
                            disabled={relation.isStatic}
                            onChange={(e) => {
                                e.syntheticEvent.stopPropagation();
                                e.nativeEvent.stopPropagation();
                                toggleShowReferenceAttribute(index)
                            }}
                            onClick={e => {
                                debugger;
                                e.stopPropagation()
                            }} />
                        &nbsp;
                        Add Reference {ATTRIBUTE_LABEL}
                    </label>
                    :
                    <>&nbsp;</>
                }
                {
                    relation.showReferenceAttribute
                    ?
                    <DropDownList
                        data={getSelectedAttributeNameOfEntity(relation.from)}
                        value={relation.referenceAttribute}
                        disabled={relation.isStatic}
                        onChange={(e) => handleReferenceAttributeChange(e, index)}
                        onOpen={e => {
                            e.syntheticEvent.stopPropagation();
                        }}
                        onClose={e => {
                            e.syntheticEvent.stopPropagation();
                        }} />
                    :
                    <>&nbsp;</>
                }
            </div>
        </div>
    </button>
</div>
*/

export default RecommendedRelationCard;